import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SignatureLevel, SignerModel, SigningStates} from "../../../sipo/model/signer-model";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {PdfDto} from "../../../sipo/model/pdf-dto";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {SipoService} from "../../../sipo/services/SipoService";
import {
    ConfirmDocumentSignComponent
} from "../../../sipo/document-signing/document-item-sign/confirm-document-sign.component";
import {OtpComponent} from "../../../sipo/document-signing/otp/otp.component";
import {FileModel} from "../../../sipo/model/file-model";
import {TranslatePipe} from "@ngx-translate/core";
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import {SkeletonModule} from "primeng/skeleton";
import {IdCardComponent} from "../id-card/id-card.component";
import {EvidenceSvgPipe} from "../../pipes/evidence-svg.pipe";
import {firstValueFrom} from "rxjs";
import {SubItemModel} from "../../../sipo/model/subItem.models";

@Component({
    selector: 'app-temporary-sign-task-details',
    standalone: true,
    imports: [
        TranslatePipe,
        SkeletonModule,
        NgIf,
        NgForOf,
        EvidenceSvgPipe
    ],
    templateUrl: './temporary-sign-task-details.component.html',
    styleUrl: './temporary-sign-task-details.component.scss'
})
export class TemporarySignTaskDetailsComponent {

    detailedData: {
        signProcess: SignerModel | null;
        documentImages: any[];
        subItems: any[];
        signaturePositions: any
    } = {
        signProcess: null,
        documentImages: [],
        subItems: [],
        signaturePositions: null
    }
    @Input() processId!: string;
    pdfDto!: PdfDto;
    @Output() closeDetailsEventEmitter = new EventEmitter();

    signState: boolean = false;
    selfSignUrl: string | null = null;


    subItemId: string | null = null;

    //this.selfSignUrl = data.url ?? `/signing/${data.process}/${data.subItem}`;
    constructor(private sipoService: SipoService,
                private router: Router) {
    }

    ngOnInit() {

        this.sipoService.getSignerModel(this.processId).subscribe({
            next: (data: SignerModel) => {
                this.detailedData.signProcess = data;
                console.log('datadatadatadatadatadata')
                console.log(data)
                console.log('datadatadatadatadatadata')
            },
            error: err => {
                console.log(err);
            }
        })

        this.getSubItems();

        setTimeout(() => {
            console.log(this.detailedData)
        }, 2500)
    }

    getImages() {

        this.detailedData.documentImages = [];

        this.sipoService.getImagesByProcess(this.processId).subscribe({
            next: value => {
                console.log(value)
                this.pdfDto = value;
                const images = value.images.sort((a, b) => a.pageNumber - b.pageNumber)
                images.forEach(image => {
                    this.detailedData.documentImages.push(
                        {
                            img: image.data.startsWith("data:image/png;base64,") ? image.data : "data:image/png;base64," + image.data,
                            width: value.width,
                            height: value.height,
                            signaturePosition: {
                                "bottom": "3%;",
                                "left": "40%;"
                            }
                        }
                    );
                });

                this.detailedData.signaturePositions = [];
                this.detailedData.subItems.forEach(subItem => {

                    this.sipoService.getPositionsByItem(subItem.id).subscribe({
                        next: positions => {
                            this.detailedData.signaturePositions.push(positions[0]);

                            console.log(positions);
                            console.log(this.detailedData.signaturePositions);
                        },
                        error: error => {
                            console.log(error);
                        }
                    });

                })

                console.log(value);
            },
            error: err => {
                console.error(err);
            }
        });
    }

    async navigateToSign() {
        const data: SubItemModel = await firstValueFrom(
            this.sipoService.postSignerSubitemByProcess(this.processId)
        );

        if (data) {
            this.selfSignUrl = `/signing/${this.processId}/${data.id}`;
            this.router.navigate([this.selfSignUrl]);
        }


        console.log(this.selfSignUrl);
        //this.selfSignUrl = value
    }

    // Sub items will be used to control the signer's sign state. In signModel's signers filed there isn't state.
    getSubItems() {

        this.detailedData.subItems = [];

        this.sipoService.getSubItemsList(this.processId).subscribe({
            next: value => {
                this.detailedData.subItems = value;
                this.subItemId = value.id;
                console.log(this.detailedData.subItems);
            },
            error: err => {
                console.error(err)
            }
        })
    }

    close() {
        this.closeDetailsEventEmitter.emit(false);
    }
}
